module.exports = __webpack_public_path__ + "static/img/29.c335d28e.jpg";